var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 59.79 56.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #003851;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -10609.85,
    y1: 11183.08,
    x2: -10609.85,
    y2: 11219.69,
    gradientTransform: "translate(-10579.21 11219.69) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6aa4a2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5da5a2",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#49a6a4",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3aa7a5",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#31a8a5",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ea9a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m35.25,27.27h-.58v-8.67c0-7.97-6.48-14.45-14.45-14.45s-14.45,6.48-14.45,14.45v8.67h-.58c-2.87,0-5.2,2.33-5.2,5.2v18.49c0,2.87,2.33,5.2,5.2,5.2h30.05c2.87,0,5.2-2.33,5.2-5.2v-18.49c0-2.87-2.33-5.2-5.2-5.2Zm-26.58-8.67c0-6.37,5.18-11.56,11.56-11.56s11.56,5.18,11.56,11.56v8.67H8.67v-8.67Zm28.89,32.36c0,1.27-1.04,2.31-2.31,2.31H5.2c-1.27,0-2.31-1.04-2.31-2.31v-18.49c0-1.27,1.04-2.31,2.31-2.31h30.05c1.27,0,2.31,1.04,2.31,2.31v18.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.78,
    y: 37.38,
    width: 2.89,
    height: 8.67,
    rx: 1.16,
    ry: 1.16
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.03 0 59.79 .12 27.37 36.61 1.49 36.61 34.03 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.e925c82f925fffc58eb9e2c026855f90.svg";
export { ForwardRef as ReactComponent };